import React, { Component } from "react";
import { connect } from "dva";
import { parse } from "qs";
import { Button, Modal } from "antd";
import ListPage from "@/components/ListPage";
import CriterionModalView from "../../components/CriterionModal";

const { ListTable } = ListPage;
const { confirm } = Modal;

@connect(({ projectCriterion }) => ({
  selectedNormRowKeys: projectCriterion.selectedNormRowKeys,
  templateList: projectCriterion.templateList,
  spinProps: projectCriterion.spinProps,
  normList: projectCriterion.normList,
  pageInfo: projectCriterion.pageInfo
}))
class RootView extends Component {
  constructor(props) {
    super(props);
    const { search } = window.location;
    const query = parse(search.split("?").pop());
    const { currentProjectId } = query;

    const columns = [
      {
        title: "指标名称",
        dataIndex: "name",
        ellipsis: true
      },
      {
        title: "指标编号",
        dataIndex: "number"
      },
      {
        title: "指标分数",
        dataIndex: "indexScore"
      }
    ];
    this.state = {
      columns,
      showCriterionModal: false,
      currentProjectId
    };
  }

  componentDidMount = () => {
    this.getModalList();
  };

  // 获取指标模板列表
  getModalList = () => {
    const { currentProjectId } = this.state;
    const { dispatch } = this.props;
    dispatch({
      type: "projectCriterion/fetchModalList",
      payload: {
        projectId: currentProjectId
      },
      callback: this.handleGetNormList
    });
  };

  // 分页改变
  handlePaginationChange = (page, pageSize) => {
    const pageInfo = { page, pageSize };
    this.getList(pageInfo);
  };

  // 获取指标模板
  handleGetNormList = pageInfo => {
    const { currentProjectId } = this.state;
    const { dispatch, respondentOrgId } = this.props;
    dispatch({
      type: "projectCriterion/fetchGetNormList",
      payload: {
        projectId: currentProjectId,
        respondentOrgId,
        page: 1,
        pageSize: 10,
        ...pageInfo
      }
    });
  };

  // 重新选择模板
  handleSetEvaluateTemplate = (templateId, isActive) => {
    const { dispatch } = this.props;
    const { currentProjectId } = this.state;
    if (isActive === "true") {
      confirm({
        content:
          "检测到该模板存在当前项目中所包含学校的个 性化指标配置，是否进行匹配？",
        cancelText: "取消",
        okText: "确定",
        onOk: () => {
          dispatch({
            type: "projectCriterion/fetchSetEvaluateTemplate",
            payload: {
              templateId,
              projectId: currentProjectId,
              enableOrg: true
            },
            callback: () => {
              this.handleGetProjectTree();
              this.getModalList();
            }
          });
        },
        onCancel: () => {
          dispatch({
            type: "projectCriterion/fetchSetEvaluateTemplate",
            payload: {
              templateId,
              projectId: currentProjectId,
              enableOrg: false
            },
            callback: () => {
              this.handleGetProjectTree();
              this.getModalList();
            }
          });
        }
      });
    } else {
      dispatch({
        type: "projectCriterion/fetchSetEvaluateTemplate",
        payload: {
          templateId,
          projectId: currentProjectId,
          enableOrg: false
        },
        callback: () => {
          this.handleGetProjectTree();
          this.getModalList();
        }
      });
    }
  };

  // 重新选择模板后获取组织树
  handleGetProjectTree = () => {
    const { currentProjectId } = this.state;
    const { dispatch, respondentOrgId, handleReselectTemplate } = this.props;
    dispatch({
      type: "tree/getEvaluateTree",
      payload: {
        projectId: currentProjectId,
        respondentOrgId
      },
      callback: handleReselectTemplate
    });
    this.setState({
      showCriterionModal: false
    });
  };

  handleShowModal = () => {
    this.setState({
      showCriterionModal: true
    });
  };

  handleChangeSelected = (selectedNormRowKeys, selectedRows) => {
    const { dispatch } = this.props;
    // 把选中的 selectedRowKeys 放入 store 中
    dispatch({
      type: "projectCriterion/save",
      payload: {
        selectedNormRowKeys
      }
    });
  };

  render() {
    const { columns, showCriterionModal } = this.state;
    const { templateList, normList, spinProps, pageInfo } = this.props;
    const pageProps = {
      spinProps
    };

    const tableProps = {
      columns,
      list: normList,
      pageInfo,
      onPageChange: this.handlePaginationChange
    };

    return (
      <ListPage {...pageProps}>
        <div className="header">
          <Button onClick={this.handleShowModal} type="primary">
            重新选择模版
          </Button>
        </div>
        <ListTable {...tableProps} />
        {showCriterionModal && (
          <CriterionModalView
            onCancel={() => this.setState({ showCriterionModal: false })}
            templateList={templateList}
            handleSetEvaluateTemplate={(templateId, isActive) =>
              this.handleSetEvaluateTemplate(templateId, isActive)
            }
          />
        )}
      </ListPage>
    );
  }
}

export default RootView;
